const getOrderItemDescription = (description) => {
    const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
    if (isHTML(description)) {
        return description.replace(/<\/?[^>]+(>|$)/g, "");
    }
    return description;
};
export default getOrderItemDescription;
//# sourceMappingURL=getOrderItemDescription.js.map